import Api from '../lib/api';
import { SPREADSHEET_ID, CALLBACK_API_URL } from '../config/constants';

const config = {

};

export default {

  push(url, row) {
    return Api(config).post(url, { row })
  },

  pushToDefaultSpreadsheet(row) {
    const url = `${CALLBACK_API_URL}callbacks/${SPREADSHEET_ID}/push`

    return this.push(url, row)
  }

}